import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Eyebrow } from "@/components/site/primitives";

const Section = ({ title, children }) => (
  <div className="mt-10">
    <h2 className="font-display text-xl font-medium tracking-tight text-bone">{title}</h2>
    <p className="mt-3 text-sm font-light leading-relaxed text-zinc-400">{children}</p>
  </div>
);

export default function Legal({ kind }) {
  const isPrivacy = kind === "privacy";
  return (
    <main data-testid={`${kind}-page`} className="mx-auto max-w-3xl px-6 py-20">
      <Eyebrow>{isPrivacy ? "Privacy policy" : "Terms of use"}</Eyebrow>
      <h1 className="mt-4 font-display text-4xl font-light tracking-tight text-bone">
        {isPrivacy ? "Your privacy" : "The house rules"}
      </h1>
      <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-smoke">
        Reel vs Real — how film shapes the way we love
      </p>

      {isPrivacy ? (
        <>
          <Section title="What we collect">
            Two things, only when you hand them to us: your email address if you join the
            premiere notify list, and whatever name and question you write in a letter to the
            show. Nothing is collected silently, and we never buy or scrape data about you.
          </Section>
          <Section title="How we use it">
            Your email is used for one purpose: a message when a new episode premieres. Letters
            may be read on the show or answered on the site. We do not sell, rent or share your
            details with anyone.
          </Section>
          <Section title="TikTok connection">
            If you are the site owner, the TikTok connection is used only to display the show's
            own videos on this website. Visitor data is never sent to TikTok by us.
          </Section>
          <Section title="Your choices">
            Every email we send has a one-tap unsubscribe link at the bottom. Want a letter
            removed from the site? Ask through the Letters section on the homepage and it will
            be done.
          </Section>
        </>
      ) : (
        <>
          <Section title="The content">
            Reel vs Real is a podcast about film and relationships hosted by Mel Masry on Nile
            FM. Episode audio and video live on platforms like YouTube, Spotify, Apple Podcasts
            and TikTok; this site links out to them.
          </Section>
          <Section title="Your letters">
            When you send a letter or question, you give us permission to read it on the show or
            publish it on this site. Keep it civil and don't include anyone else's private
            details.
          </Section>
          <Section title="The notify list">
            Joining the premiere list means one email per episode premiere. You can leave at any
            time by asking through the Letters section.
          </Section>
          <Section title="Changes">
            If these terms change, the update appears on this page.
          </Section>
        </>
      )}

      <Link
        to="/"
        data-testid="legal-back-link"
        className="mt-14 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-smoke transition-colors hover:text-bone"
      >
        <ArrowLeft size={12} /> Back to the show
      </Link>
    </main>
  );
}
